import { Suspense } from 'react';

import CartModal from '@frontend/storefront/components/cart/modal';
import OpenCart from '@frontend/storefront/components/cart/open-cart';
import MobileMenu from '@frontend/storefront/components/layout/navbar/mobile-menu';
import { useStorefrontData } from '@frontend/storefront/data';
import Image from '@frontend/storefront/Image';
import { Menu } from '@frontend/storefront/lib/shopify/types';
import Link from '@frontend/storefront/Link';

const SITE_NAME = 'nopad';

export function Navbar() {
  const menu = useStorefrontData().menus['main-menu'];

  return (
    <nav className="relative mx-auto flex max-w-[1312px] items-center justify-between p-4">
      <div className="block flex-none md:hidden">
        <Suspense fallback={null}>
          <MobileMenu menu={menu} />
        </Suspense>
      </div>
      <div className="flex w-full items-center">
        <div className="flex w-full md:w-2/3">
          <Link
            href="/"
            prefetch={true}
            className="mr-2 flex w-full items-center justify-center md:w-auto lg:mr-6"
          >
            <Image
              src="/home/logo.svg"
              alt={SITE_NAME || 'nopad'}
              width={80}
              height={24}
              preload
            />
          </Link>
          {menu.length ? (
            <ul className="hidden gap-6 text-sm md:flex md:items-center">
              {menu.map((item: Menu) => (
                <li key={item.title}>
                  <Link
                    href={item.path}
                    prefetch={true}
                    className="text-np-ink/70 underline-offset-4 hover:text-np-ink hover:underline"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          ) : null}
        </div>
        <div className="flex justify-end md:w-1/3">
          <Suspense fallback={<OpenCart />}>
            <CartModal />
          </Suspense>
        </div>
      </div>
    </nav>
  );
}
